import { validateFlowStepConfig } from '../flow-core';
import type { StepFlowStepComponent } from './types';

/**
 * Validate step configuration
 * Re-export from flow-core with StepFlow types
 */
export function validateStepConfig(steps: StepFlowStepComponent[]) {
  return validateFlowStepConfig(steps);
}
